import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a0c8ovfuxn: FaireBrandEntity = {
  token: "b_a0c8ovfuxn",
  type: "brand",
  name: "Creative Energy Candles",
  avatarUrl:
    "https://cdn.faire.com/fastly/502f77c1efbe6e7b8a175799a549c88615d76e2872503af87805a7bbb625f009.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e6cd47f8c3746233a8173165439e5f836aa5e14c11acf3c9c1dc1b4ae3756afe.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/502f77c1efbe6e7b8a175799a549c88615d76e2872503af87805a7bbb625f009.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e6cd47f8c3746233a8173165439e5f836aa5e14c11acf3c9c1dc1b4ae3756afe.jpeg",
  location: "Columbia, SC, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 256,
  isInsider: true,
  description:
    "Creative Energy Candles began in 2010 on Kara’s kitchen stove about the same time the marketing firm she was working for closed its doors. Since she always loved playing with melted candle wax, she wanted to create a candle that was also beneficial for your skin. After researching the best natural ingredients, she developed a unique recipe featuring 100% soybean wax, organic extra virgin coconut oil and essential oil blends. Kara took her candle and hit the road selling to high end boutiques and day spas around the Southeast. Her big (little) break – as she likes to say – came when her candle landed in the hands of Marlo Thomas, actress and philanthropist. Marlo promoted the Creative Energy Candle as “Her Favorite Candle” on the front page of AOL for Valentines Day. After that, Kara never looked back!  \n\nAfter embarking on her entrepreneurial adventure, Kara still puts her graphics design background to good use. She designs all of Creative Energy’s product packaging as well as marketing materials.\n\nKara believes in giving back and donates 10% of our profits to benefit various charities and missions. You can find Creative Energy Candles all of the United States in various boutiques, gift shops, spas, pharmacies and natural grocery stores – including Whole Foods Market, Wegmans, Paper Source and The Paper Store.  ",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:11.226Z",
    importedBy: "entity-db-cli",
  },
};
